import { AutogenLayoutDriverEmploymentHistory } from "./autogen/AutogenLayoutDriverEmploymentHistory";

export class DriverEmploymentHistory extends AutogenLayoutDriverEmploymentHistory {

}
